import React, { ReactElement, useEffect } from 'react';
import { Link, Loader } from 'idsk-react-components';
import {
  Breadcrumbs, getTitle, homeBreadcrumb, setTitle,
} from 'slovlex-idsk-react-components';
import { useParams } from 'react-router';
import routes from '../../../routing/routes';
import GlobalErrors from '../../../module/GlobalErrors';
import PageHeadingWithBackButton from '../../../module/PageHeadingWithBackButton';
import Layout from '../../Layout';
import SecuredPage from '../../../module/SecuredPage';
import useTerminHistoriaZmienPage from '../../../module/Admin/Termin/HistoriaZmien/hook/useTerminHistoriaZmienPage';
import TerminHistoriaZmien from '../../../module/Admin/Termin/HistoriaZmien';
import UserRoleEnum from '../../../model/currentuser/UserRole';
import useTerminHistoriaZmienPageInfo
  from '../../../module/Admin/Termin/HistoriaZmien/hook/useTerminHistoriaZmienPageInfo';

const AdminTerminHistoriaZmienPage = (): ReactElement => {
  const {
    terminHistoriaZmienPage,
    terminHistoriaZmienStatus,
    pageNumber,
  } = useTerminHistoriaZmienPage();

  const {
    terminHistoriaZmienPageInfo,
    terminHistoriaZmienPageInfoStatus,
  } = useTerminHistoriaZmienPageInfo();

  const {
    tezaurusUuid,
    terminUuid,
  } = useParams<{ tezaurusUuid: string, terminUuid: string }>();

  useEffect(() => {
    if (!terminHistoriaZmienPageInfoStatus?.loading) {
      setTitle(getTitle());
    }
  }, [terminHistoriaZmienPageInfoStatus?.loading]);

  return (
    <Layout>
      <Breadcrumbs routeList={[
        homeBreadcrumb(process.env.REACT_APP_PORTAL_MAIN_URL),
        {
          to: routes.tezaurus.admin.list,
          heading: 'Administrácia tezaurov',
        },
        {
          to: routes.tezaurus.admin.termin.list.withParams(tezaurusUuid),
          heading: terminHistoriaZmienPageInfo?.tezaurusNazov || 'Zoznam termínov',
        },
        {
          to: routes.tezaurus.admin.termin.detail.withParams(tezaurusUuid, terminUuid),
          heading: 'Úprava termínu',
        },
        {
          to: routes.tezaurus.admin.termin.historiaZmien.withParams(tezaurusUuid, terminUuid),
          heading: 'História zmien termínu',
        },
      ]}
      />
      <GlobalErrors />
      <Loader loading={terminHistoriaZmienPageInfoStatus?.loading}>
        <SecuredPage
          allowForRoles={[UserRoleEnum.ADMINISTRATOR_TEZAURUS, UserRoleEnum.REDAKTOR_TEZAURUS]}
          requestStatus={terminHistoriaZmienPageInfoStatus?.responseCode}
        >
          {terminHistoriaZmienPageInfo && (
            <>
              <PageHeadingWithBackButton
                heading={terminHistoriaZmienPageInfo.terminNazov}
                backLinkRoute={routes.tezaurus.admin.termin.detail.withParams(tezaurusUuid, terminUuid)}
                headingCaption="História zmien termínu"
              />
              <Link
                to={routes.tezaurus.admin.termin.detail.withParams(tezaurusUuid, terminUuid)}
                type="button-third"
                size="large"
              >Späť
              </Link>
              <Loader loading={terminHistoriaZmienStatus?.loading}>
                {terminHistoriaZmienPage && (
                <TerminHistoriaZmien
                  terminHistoriaZmienPage={terminHistoriaZmienPage}
                  pageNumberFromUrl={pageNumber}
                />
                )}
              </Loader>
            </>
          )}
        </SecuredPage>
      </Loader>
    </Layout>
  );
};

export default AdminTerminHistoriaZmienPage;
